import ENV from "app/utils/ENV";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import valueHelpers from "app/utils/valueHelpers";
import colorHelpers from "app/utils/colorHelpers";
import store from "app/redux/store";

let chapterHelpers = {
  subChapters(chapter) {
    // if (chapter?.id == 452) return [];
    let subChapters = chapter.sub_chapters || [];
    if (chapter.sub_chapter_ids) {
      let { chapters } = store.getState();
      subChapters = chapters.filter((c) =>
        chapter.sub_chapter_ids.includes(c.id),
      );
      // subChapters = textHelpers.sortByIds(chapter.sub_chapter_ids, subChapters);
      subChapters = textHelpers.oldestFirst(subChapters, "start_at");
    }
    return subChapters;
  },
  getChapterChunk(chapter) {
    let chunk = "other";
    if ([1].includes(chapter.range)) {
      chunk = "day";
    } else if ([7].includes(chapter.range)) {
      chunk = "week";
    } else if ([28, 29, 30, 31].includes(chapter.range)) {
      chunk = "month";
    } else if ([90, 91, 92, 93].includes(chapter.range)) {
      chunk = "season";
    } else if ([365, 366].includes(chapter.range)) {
      chunk = "year";
    }
    return chunk;
  },
  includesProgress(chapter, timestamps, returnAll = false) {
    let timestamp = returnAll ? [] : null;
    for (let ts of timestamps) {
      if (timeHelpers.withinRange(ts, chapter)) {
        // console.log("includes progress", chapter, ts);
        if (returnAll) timestamp.push(ts);
        else timestamp = ts;
        if (!returnAll) break;
      }
    }
    return timestamp;
  },
  includes(chapter, ts) {
    return timeHelpers.withinRange(ts, chapter);
  },
  nextTitle(subChapters) {
    let title = "";
    subChapters = subChapters.filter((c) => c.id != "auto");
    if (subChapters?.length) {
      let prevChapter = subChapters[subChapters.length - 1];
      let chunk = chapterHelpers.getChapterChunk(prevChapter);
      if (chunk == "day") {
        title = timeHelpers.getDayOfWeek(
          timeHelpers.tomorrow(prevChapter.end_at),
        );
      } else if (chunk == "week") {
        // title = "tricky week naming...";
      } else if (chunk == "month") {
        title = timeHelpers.getMonthName(
          timeHelpers.tomorrow(prevChapter.end_at),
        );
      } else if (chunk == "season") {
        if (prevChapter.title == "Spring") title = "Summer";
        else if (prevChapter.title == "Summer") title = "Autumn";
        else if (prevChapter.title == "Autumn") title = "Winter";
        else if (prevChapter.title == "Winter") title = "Spring";
      } else if (chunk == "year") {
        title = timeHelpers.tomorrow(prevChapter.end_at).getFullYear();
      }
    }
    return title;
  },
  nextStartAt(subChapters) {
    let startAt = null;
    subChapters = subChapters.filter((c) => c.id != "auto");
    if (subChapters?.length) {
      let lastSubChapter = subChapters[subChapters.length - 1];
      startAt = timeHelpers.tomorrow(lastSubChapter.end_at);
      startAt = timeHelpers.dateTimeToDate(startAt);
    }
    return startAt;
  },
  nextEndAt(subChapters) {
    let endAt = null;
    subChapters = subChapters.filter((c) => c.id != "auto");
    if (subChapters?.length) {
      let lastSubChapter = subChapters[subChapters.length - 1];
      let nextRange = chapterHelpers.nextRange(subChapters);
      endAt = timeHelpers.tomorrow(lastSubChapter.end_at, nextRange);
      endAt = timeHelpers.dateTimeToDate(endAt);
    }
    return endAt;
  },
  nextRange(subChapters) {
    let range = 1;
    subChapters = subChapters.filter((c) => c.id != "auto");
    if (!!subChapters.length) {
      let prevChapter = subChapters[subChapters.length - 1];
      range = prevChapter.range;
      let chunk = chapterHelpers.getChapterChunk(prevChapter);
      if (chunk == "day") {
        range = 1;
      } else if (chunk == "week") {
        range = 7;
      } else if (chunk == "month") {
        let nextStartAt = chapterHelpers.nextStartAt(subChapters);
        let endOfMonth = timeHelpers.endOfMonth(nextStartAt);
        // let middleOfNextMonth = timeHelpers.tomorrow(nextStartAt, 31)
        // let startOfNextMonth = timeHelpers.beginningOfMonth(nextStartAt, 1);
        // let endOfMonth = timeHelpers.yesterday(startOfNextMonth);
        let monthRange = Math.round(timeHelpers.diff(endOfMonth, nextStartAt));
        range = monthRange;
      } else if (chunk == "season") {
        let nextStartAt = chapterHelpers.nextStartAt(subChapters);
        // format: "YYYY-MM-DD"
        let year = nextStartAt.split("-")[0];
        let month = nextStartAt.split("-")[1];
        let endOfSeason = timeHelpers.tomorrow(nextStartAt, 90);
        if (month == "03") {
          endOfSeason = new Date(year, 5, 20);
        } else if (month == "06") {
          endOfSeason = new Date(year, 8, 20);
        } else if (month == "09") {
          endOfSeason = new Date(year, 11, 20);
        } else if (month == "12") {
          endOfSeason = new Date(year + 1, 2, 20);
        }
        let seasonRange = Math.round(
          timeHelpers.diff(endOfSeason, nextStartAt),
        );
        range = seasonRange;
      } else if (chunk == "year") {
        let nextStartAt = chapterHelpers.nextStartAt(subChapters);
        let endOfYear = timeHelpers.endOfYear(nextStartAt);
        let yearRange = Math.round(timeHelpers.diff(endOfYear, nextStartAt));
        range = yearRange;
      }
    }
    return range;
  },
  suggestedSubChapter(parent, lastSibling = {}) {
    // console.log("suggested from:", parent, lastSibling);
    let title = "";
    let nextStartAt = undefined;
    let nextEndAt = undefined;

    let prevEndAt =
      timeHelpers.dateToDateTime(lastSibling?.end_at) || new Date();
    let nextDay = new Date(prevEndAt.getTime() + timeHelpers.msInDay);

    if (parent.range == 1) {
      // parent is a day
    } else if (
      parent.range < 28
      // && timeHelpers.getDayOfWeek(parent.end_at) == "Sunday"
    ) {
      // parent is week
      // return next week day
      title = timeHelpers.getDayOfWeek(nextDay);
      nextStartAt = timeHelpers.dateTimeToDate(nextDay);
    } else if ([28, 29, 30, 31].includes(parent.range)) {
      // parent is a month
      // return next week
      title = "[nth] week of [month]";
    } else if (true) {
      // return next month
      title = timeHelpers.getMonthName(nextDay);
    }

    let subRange = (lastSibling?.range || 1) - 1;
    if (!!nextStartAt) {
      nextEndAt = timeHelpers.tomorrow(nextDay, subRange);
      nextEndAt = timeHelpers.dateTimeToDate(nextEndAt);
    }

    // console.log({
    //   lsea: lastSibling?.end_at,
    //   prevEndAt,
    //   nextDay,
    //   nextStartAt,
    //   nextEndAt,
    //   subRange,
    // });

    return {
      id: title,
      title,
      start_at: nextStartAt,
      end_at: nextEndAt,
      // start_at: timeHelpers.dateTimeToDate(
      //   parent.range <= 7 ? undefined : timeHelpers.beginningOfMonth(null, 1)
      // ),
      // end_at: timeHelpers.dateTimeToDate(
      //   parent.range <= 7 ? undefined : timeHelpers.endOfMonth(null, 1)
      // ),
    };
  },
  guessSubRange(chapter = {}) {
    let range = 1;
    if (chapter.range == 1) {
      range = 1;
    } else if (chapter.range <= 7) {
      range = 1;
    } else if (chapter.range <= 31) {
      range = 7;
    } else if (chapter.range <= 93) {
      range = 30; // ?
    } else {
      range = 1;
    }
    return range;
  },
  getPropagatedProgress(chapter, value, descendantIds = null, level = 0) {
    let progressions = [];
    let subChapters = chapterHelpers.subChapters(chapter);
    if (descendantIds == null)
      descendantIds = valueHelpers.getDescendants(value, true).map((v) => v.id);
    for (let sc of subChapters) {
      let m = sc.moments?.find(
        (m) => !!m.completed_at && descendantIds.includes(m.value_id),
      );
      if (!!m) {
        progressions.push(m.completed_at);
      } else {
        let subProgressions = chapterHelpers.getPropagatedProgress(
          sc,
          value,
          descendantIds,
          level + 1,
        );
        if (subProgressions.length) {
          progressions.push(subProgressions[0]);
        }
      }
    }
    // console.log(
    //   `getting propagated progress for ${value.text}, ${level}`,
    //   chapter,
    //   progressions,
    //   subChapters,
    //   descendantIds
    // );
    return progressions;
  },
  suggestedRange(parent) {},
  atemporal(chapter = {}) {
    if (!chapter.start_at || !chapter.end_at) return true;
    return false;
  },
  getTitle(chapter = {}, isToday = false, includeDate = false) {
    let title = chapter.title;
    // if (isToday) {
    //   if (!title?.length) {
    //     title = "Today";
    //   }
    // }
    if (!title) {
      if (!!chapter.start_at && chapter.start_at == chapter.end_at) {
        title = timeHelpers.getDayOfWeek(
          timeHelpers.dateToDateTime(chapter.start_at),
        );
      } else {
        title = `${textHelpers.formatDate(
          timeHelpers.dateToDateTime(chapter.start_at),
          true,
          false,
          false,
        )} - ${textHelpers.formatDate(
          timeHelpers.dateToDateTime(chapter.end_at),
          true,
          false,
          false,
        )}`;
      }
    }
    if (includeDate && !!chapter.start_at) {
      title += ` ${textHelpers.formatDate(
        timeHelpers.dateToDateTime(chapter.start_at),
        true,
        false,
      )}`;
    }
    return title;
  },
  getColor(chapter = {}, colors, colorScheme) {
    if (!chapter?.id) return "transparent";
    // generated items (narration, tarot) don't tint the chapter
    let moments =
      chapter?.moments?.filter(
        (m) => !["narration", "tarot"].includes(m.value?.category),
      ) || [];
    let hasCompletedMoments = moments.some((m) => !!m.completed_at);
    // hasCompletedMoments = false;
    let colorNames = moments
      .map((m) =>
        hasCompletedMoments
          ? !!m.completed_at
            ? m.value?.color
            : null
          : m.value?.color,
      )
      .filter((c) => !!c);
    let hexes = colorNames.map((c) => valueHelpers.colorAsHex(c, colorScheme));

    let atemporal = chapterHelpers.atemporal(chapter);

    let color = atemporal
      ? colors.empty
      : !!hexes.length
      ? colorHelpers.averageColor(hexes)
      : colors.trim;

    let colorF = colorHelpers.hexAsFloat(color);
    if (colorF > 0.5) {
      let darkenBy = colorF - 0.5;
      let darkenTo = 1.0 - darkenBy;
      color = colorHelpers.modifyHex(color, darkenTo);
    }
    return color;
  },
  autocompleteChapterNames(query = "") {
    if (!query?.length) return [];
    // friday, next week, next thurs, in 2 months, next nov
    let chapters = [];
    let relationships = ["Last", "Next"];
    let ranges = [
      "week",
      "month",
      "season",
      "year",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    for (let relat of relationships) {
      for (let range of ranges) {
        let desc = `${relat} ${range}`;
        if (desc.toLowerCase().includes(query.toLowerCase())) {
          chapters.push({ title: desc, id: "auto" });
        }
      }
    }
    return chapters;
  },
  isNested(chapterMoments, moment) {
    let isNested = false;
    let isNestedUnder = null;
    if (!!chapterMoments) {
      for (let pid of moment.value?.parent_ids || []) {
        let nestedUnder = chapterMoments.find(
          (cm) =>
            cm.value?.id == pid &&
            (true ||
              (cm.value.color == moment.value.color &&
                cm.value.icon == moment.value.icon)),
        );
        if (!!nestedUnder) {
          isNested = true;
          isNestedUnder = nestedUnder;
          break;
        }
      }
    }
    return isNestedUnder;
    return isNested;
  },
};

export default chapterHelpers;
